const CustomDropdownCell = (props) => {
    const { data, innerRef, innerProps } = props;

    const tooltipProps = data.isDisabled
        ? { title: data.reason || "Option disabled" }
        : {};

    return (
        <div
            ref={innerRef}
            {...innerProps}
            {...tooltipProps}
            style={{
                padding: "8px 12px",
                color: data.isDisabled ? "#999" : "inherit",
                backgroundColor: props.isFocused
                    ? data.isDisabled
                        ? "#f0f0f0"
                        : "#eee"
                    : "white",
                cursor: data.isDisabled ? "not-allowed" : "pointer",
                opacity: data.isDisabled ? 0.6 : 1,
            }}
        >
            {data.label}
        </div>
    );
};

export default CustomDropdownCell;
